var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shouldShowQrcode
    ? _c(
        "div",
        { staticClass: "totp-qrcode" },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: _vm.label, prop: "googleVerify" } },
            [
              _c("vue-qrcode", {
                key: _vm.googleVerify,
                attrs: { value: _vm.totpUri, options: _vm.qrcodeOptions },
              }),
              _c(
                "p",
                { staticClass: "qrcode-tip" },
                [
                  _c("a-icon", { attrs: { type: "mobile" } }),
                  _vm._v(" 请使用 Google Authenticator 扫描二维码 "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }